// This import loads the firebase namespace.
import firebase from 'firebase/app';

// These imports load individual services into the firebase namespace.
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyD1AZqyGaQjneYMtZfI6tA2tXADAT_rdGY',
  authDomain: 'api-project-799824656825.firebaseapp.com',
  projectId: 'api-project-799824656825',
  databaseURL: 'https://adminonlineusers.europe-west1.firebasedatabase.app/',
};

firebase.initializeApp(firebaseConfig);

export const firestore = firebase.firestore();
export const fieldValue = firebase.firestore.FieldValue;
export const firebaseauth = firebase.auth();
export const messagesRef = firestore.collection('messages');
export const channelsRef = firestore.collection('channels');
export const usersRef = firestore.collection('users');
export const realtimeDb = firebase.database();
